module.exports = __webpack_public_path__ + "resources/img/img_voice_studio1_en.2d5aadc969129c088fa14109aa0fe862.png";